export function getConfiguredMobileDownloadUrl(value: string | undefined): string | null {
  const configuredValue = value?.trim();
  if (!configuredValue) return null;

  try {
    const url = new URL(configuredValue);
    return url.protocol === "https:" ? url.href : null;
  } catch {
    return null;
  }
}

export function resolveConfiguredMobileDownloadUrl(
  platformUrl: string | undefined,
  genericUrl: string | undefined,
): string | null {
  return getConfiguredMobileDownloadUrl(platformUrl)
    ?? getConfiguredMobileDownloadUrl(genericUrl);
}
